import apiService from 'services/apiService';

const baseUrl = `${window._env_.PLATFORM_API_DOMAIN}`;

const postNewEntity = (body) => {
  const url = `${baseUrl}/v1/entities`;
  return apiService.post(url, body);
};

export { postNewEntity };
